import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberCybercrime = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M22.686 16.892a1 1 0 0 1 .942 1.053c-.01.185-.018.337-.018.485 0 3.217 1.86 7.326 4.518 9.481 1.134.91 2.35 1.419 3.582 1.419 1.234 0 2.46-.511 3.593-1.419 2.657-2.155 4.517-6.264 4.517-9.481v-.11a1 1 0 1 1 2 0v.11c0 3.802-2.12 8.491-5.26 11.037l-.005.003c-1.386 1.111-3.04 1.86-4.845 1.86-1.807 0-3.45-.75-4.835-1.86l-.005-.003c-3.14-2.546-5.26-7.235-5.26-11.037 0-.208.011-.412.02-.585l.002-.01a1 1 0 0 1 1.053-.944",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M35.736 27.717a1 1 0 0 1 1.167.799l1.16 6.2a1 1 0 1 1-1.966.368l-1.16-6.2a1 1 0 0 1 .8-1.167m-8.053 0a1 1 0 0 1 .799 1.167l-1.19 6.368a1 1 0 0 1-1.993-.122v-.01a1 1 0 0 1 .017-.184l1.2-6.42a1 1 0 0 1 1.167-.8",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M31.45 16.04c-6.664 0-11.66 4.254-11.66 9.07 0 4.922 5.121 10.04 11.66 10.04s11.66-5.127 11.66-10.04c0-4.806-4.997-9.07-11.66-9.07m-13.66 9.07c0-6.324 6.344-11.07 13.66-11.07 7.317 0 13.66 4.756 13.66 11.07 0 6.208-6.218 12.04-13.66 12.04-7.441 0-13.66-5.822-13.66-12.04",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M23.363 9.327c-2.198 3.959-3.583 9.385-3.583 15.123a1 1 0 0 1-2 0c0-6.032 1.45-11.8 3.834-16.094 2.36-4.25 5.79-7.296 9.826-7.296s7.466 3.046 9.826 7.296C43.65 12.65 45.1 18.418 45.1 24.45a1 1 0 0 1-2 0c0-5.738-1.385-11.164-3.583-15.123-2.223-4.003-5.123-6.267-8.077-6.267s-5.854 2.264-8.077 6.267m-1.413 21.5a1 1 0 0 1-.636 1.262c-5.752 1.9-9.904 7.325-9.904 13.72v5.34a1 1 0 1 1-2 0v-5.34c0-7.283 4.728-13.457 11.277-15.619a1 1 0 0 1 1.263.636m18.871.109a1 1 0 0 1 1.284-.594 16.53 16.53 0 0 1 9.878 10.007 1 1 0 0 1-1.886.664 14.53 14.53 0 0 0-8.682-8.793 1 1 0 0 1-.594-1.284",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M1.64 10.77a3.95 3.95 0 0 1 3.95-3.95H23.1a1 1 0 1 1 0 2H5.59c-1.078 0-1.95.872-1.95 1.95v37.69c0 1.066.87 1.94 1.95 1.94h39.73a1 1 0 1 1 0 2H5.59a3.947 3.947 0 0 1-3.95-3.94zm37.37-2.95a1 1 0 0 1 1-1h18.06a3.95 3.95 0 0 1 3.95 3.95v37.69a3.92 3.92 0 0 1-1.638 3.193 1 1 0 0 1-1.164-1.626c.486-.349.802-.92.802-1.567V10.77c0-1.078-.872-1.95-1.95-1.95H40.01a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M24.898 51.281a1 1 0 0 1 .982-.811h14.01a1 1 0 0 1 .982.811l1.37 7.12a1 1 0 0 1-.982 1.189H24.51a1 1 0 0 1-.982-1.189zm1.808 1.189-.985 5.12h14.328l-.985-5.12z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M20.17 58.59a1 1 0 0 1 1-1h23.44a1 1 0 1 1 0 2H21.17a1 1 0 0 1-1-1M52.7 36.54a1 1 0 0 1 .882.53l9.02 16.92a1 1 0 0 1-.882 1.47H43.68a1 1 0 0 1-.882-1.47l9.02-16.92a1 1 0 0 1 .882-.53m-7.354 16.92h14.708L52.7 39.666zm7.364-10.15a1 1 0 0 1 1 1v3.38a1 1 0 1 1-2 0v-3.38a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M52.71 51.94a1 1 0 1 0 0-2 1 1 0 0 0 0 2" })
	]
});
export default SvgCyberCybercrime;
